import { MapContainer, TileLayer, CircleMarker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";

function ClickHandler({ onPick }) {
  useMapEvents({ click: (e) => onPick(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6))) });
  return null;
}

export function LocationMap({ lat, lng, onPick, readOnly }) {
  const has = lat != null && lng != null && lat !== "" && lng !== "";
  const center = has ? [Number(lat), Number(lng)] : [39.5, -8.0];
  return (
    <div className="rounded-xl overflow-hidden border border-[#1E3A56] h-72 relative z-0" data-testid="location-map">
      <MapContainer center={center} zoom={has ? 15 : 6} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }} key={has ? "set" : "unset"}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {has && <CircleMarker center={center} radius={10} pathOptions={{ color: "#C9A84C", fillColor: "#C9A84C", fillOpacity: 0.6 }} />}
        {!readOnly && <ClickHandler onPick={onPick} />}
      </MapContainer>
    </div>
  );
}
